<section class="client-management">
    <div class="row">
        <div class="col-md-12">
            <app-breadcrumb *ngIf="!planning" [routePath2]="'/customer-order'" [title2]="'ORDERMANAGEMENT.MANAGEORDERS.title'"
                [title3]="title" [type]="'ORDERMANAGEMENT.MANAGEORDERS.OrderDetail'">
            </app-breadcrumb>
        </div>
        <div class="col-md-12">
            <div class="common-stepper add-edit-scope-stepper">
                <div class="table-content box-style">
                    <div class="box-style shadow-none company-info">
                        <div class="table-heading top-heaing">
                            <h3 style="font-weight: 600"><span> {{ "ORDERMANAGEMENT.MANAGEORDERS.OrderDetail" |
                                    translate }}</span>
                            </h3>
                        </div>
                        <div class="box-style shadow-none company-info" *ngIf="customerDetails">
                            <div class="company-details">
                                <div class="detail-wrapper bg-grey">
                                    <div class="detail-box">
                                        <label>{{'ExecuteOrder.ManageProposal.customer' | translate}}</label>
                                        <p>{{customerDetails?.companyName ? customerDetails?.companyName : '-'}}
                                        </p>
                                    </div>
                                    <div class="detail-box">
                                        <label>{{'ExecuteOrder.ManageProposal.subject' | translate}}</label>
                                        <p>{{ customerDetails.orderName ? customerDetails.orderName : '-' }}</p>
                                    </div>
                                    <div class="detail-box">
                                        <label>{{'ORDERMANAGEMENT.OrderId' | translate}}</label>
                                        <p>{{ customerDetails.proposalId ? customerDetails.proposalId : '-' }}</p>
                                    </div>

                                    <!-- <div class="detail-box">
                                        <label>{{'ORDERMANAGEMENT.MANAGEORDERS.CustomerEmail' |
                                            translate}}</label>
                                        <p>{{ customerDetails.email ? customerDetails.email : '-' }}</p>
                                    </div> -->
                                    <div class="detail-box">
                                        <label>{{'ExecuteOrder.ManageProposal.deadline' |
                                            translate}}</label>
                                        <p>{{ (customerDetails.completionTime | date : 'dd/MM/yyyy') ?
                                            (customerDetails.completionTime | date : 'dd/MM/yyyy') :
                                            '-'}}
                                        </p>
                                    </div>
                                    <div class="detail-box">
                                        <label>{{'ExecuteOrder.ManageProposal.budget' | translate}}</label>
                                        <p>
                                            {{customerDetails?.budget ? (customerDetails?.budget | customCurrency) : '-'}}
                                        </p>
                                    </div>
                                    <div class="detail-box">
                                        <label>{{'Procurement_Management.Status' | translate}}</label>
                                        <p>
                                            <span *ngIf="customerDetails.customerStatus === orderStatusApproveRejet.pending">
                                                {{'ExecuteOrder.ManageProposal.Open' | translate}}
                                            </span>
                                            <span *ngIf="customerDetails.customerStatus === orderStatusApproveRejet.approved">
                                                {{'ExecuteOrder.ManageProposal.Accepted' | translate}}
                                            </span>
                                            <span *ngIf="customerDetails.customerStatus === orderStatusApproveRejet.reject">
                                                {{'ExecuteOrder.ManageProposal.Rejected' | translate}}
                                            </span>
                                            <span
                                                *ngIf="customerDetails.customerStatus === orderStatusApproveRejet.IN_PROGRESS">
                                                {{'ORDERMANAGEMENT.MANAGEORDERS.IN_PROGRESS' | translate}}
                                            </span>
                                            <span
                                                *ngIf="customerDetails.customerStatus === orderStatusApproveRejet.REVIEW_OFFER">
                                                {{'ExecuteOrder.ManageProposal.Proposal' | translate}}
                                            </span>
                                            <span *ngIf="customerDetails.customerStatus === orderStatusApproveRejet.IN_REVIEW">
                                                {{'ORDERMANAGEMENT.MANAGEORDERS.IN_PROGRESS' | translate}}
                                            </span>
                                            <span *ngIf="customerDetails.customerStatus === orderStatusApproveRejet.REFUSED">
                                                {{'ExecuteOrder.ManageProposal.Refused' | translate}}
                                            </span>
                                        </p>
                                    </div>
                                    <div class="detail-box">
                                        <label>{{'ORDERMANAGEMENT.MANAGEORDERS.SignContact' | translate}}</label>
                                        <ng-container *ngFor="let file of signedContractPdf">
                                            <div class="d-flex align-items-center">
                                                {{file.file ? file.file : '-' }} ({{ formatBytes(file.size) }})
                                                <span class="download"
                                                    (click)="viewPdf(file.id, file.file)"><mat-icon>remove_red_eye</mat-icon>
                                                </span>
                                            </div>
                                        </ng-container>
                                    </div>
                                    <div class="col-xl-12 attachments ">
                                        <label>{{'ORDERMANAGEMENT.Attachments' | translate}}</label>
                                        <ng-container *ngFor="let file of documentInputs">
                                            <div class="d-flex align-items-center">
                                                {{file.file }} ({{ formatBytes(file.size) }})
                                                <span title="Download image file" class="download"
                                                    (click)="downloadImageFile(file.id, file.file)"><mat-icon>cloud_download</mat-icon></span>
                                            </div>
                                        </ng-container>
                                    </div>
                                    <div class="col-xl-12 description-section">
                                        <div class="detail-box">
                                            <label>{{'ExecuteOrder.ManageProposal.executiveSummary' | translate}}</label>
                                            <p>{{ customerDetails.description ? customerDetails.description :'-' }}
                                            </p>
                                        </div>
                                        <div class="detail-box">
                                            <label>{{'ORDERMANAGEMENT.TaskActivities' | translate}}</label>
                                            <li *ngFor="let task of taskOrActivities">{{ task }}</li>
                                        </div>
                                    </div>
                                    <div class="col-xl-12 description-section" *ngIf="customerDetails?.rejectReason">
                                        <div class="detail-box">
                                            <label>{{'ExecuteOrder.ManageProposal.rejectReason' | translate}}</label>
                                            <p>{{ customerDetails.rejectReason ? customerDetails.rejectReason :'-' }}
                                            </p>
                                        </div>
                                    </div>
                                    <!-- <div class="col-xl-12"   *ngIf="dataSource" >
                                        <div class="overflow-x-auto table-container mat-elevation-z8">
                                            <table mat-table [dataSource]="dataSource" class="even-columns-table text-left">

                                                <ng-container matColumnDef="name" style="min-width: 360px;">
                                                    <th mat-header-cell *matHeaderCellDef>
                                                        <span>{{ 'Rejcted Reason' | translate }}</span>
                                                    </th>
                                                    <td mat-cell *matCellDef="let data">{{ data.reason }}</td>
                                                </ng-container>
                                    
                                                <ng-container matColumnDef="status">
                                                    <th mat-header-cell *matHeaderCellDef>
                                                        {{ 'Procurement_Management.Status' | translate }}
                                                    </th>
                                                    <td mat-cell *matCellDef="let data" style="white-space: break-spaces;text-transform:capitalize;">
                                    
                                                        <span class="btn-style declined label-btn sm-btn table-btn"
                                                            *ngIf="data.status === orderStatusApproveRejet.reject">
                                                            {{'ExecuteOrder.ManageProposal.Rejected' | translate}}
                                                        </span>
                                    
                                                        <span class="btn-style declined label-btn sm-btn table-btn"
                                                            *ngIf="data.status === orderStatusApproveRejet.REFUSED">
                                                            {{'ExecuteOrder.ManageProposal.Refused' | translate}}
                                                        </span>
                                                    </td>
                                                </ng-container>
                                                <ng-container matColumnDef="creted at">
                                                    <th mat-header-cell *matHeaderCellDef>
                                                        <span>{{ 'ORDERMANAGEMENT.MANAGEORDERS.CreatedDate' | translate }}</span>
                                                    </th>
                                                    <td mat-cell *matCellDef="let data">{{ data.createdAt ? (data.createdAt | date : 'dd/MM/yyyy HH:mm')  : '' }}</td>
                                                </ng-container>
                                                
                                    
                                                <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                                            </table>
                                    
                                            <div *ngIf="dataSource?.length == 0" class="no-record text-center mt-15">
                                                {{ 'TABLE.No_record_found' | translate }}
                                            </div>
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>